import { render, staticRenderFns } from "./TimTeknis.vue?vue&type=template&id=6a3f147d&"
import script from "./TimTeknis.vue?vue&type=script&lang=js&"
export * from "./TimTeknis.vue?vue&type=script&lang=js&"
import style0 from "./TimTeknis.vue?vue&type=style&index=0&id=6a3f147d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports